import React, { useState } from 'react';
import CardHeadMenu from '../Card/CardHeadMenu/CardHeadMenu';
import PrescriptionTable from './PrescriptionTable';

const Prescriptions = () => {
    //#region code
    const [isChanged, setIsChanged] = useState(false);
    const [editData, setEditData] = useState(null);

    //#endregion

    return (
        <>
            <CardHeadMenu
                prefix={"Na"}
                suffix={"Na"}
                title={"PRESCRIPTIONS"}
                // handlePopup={handlePopup}
                // isEdit={isEdit}
                // create={isCreate}
                showCreate={false}
            />
            <PrescriptionTable />
        </>
    )
}

export default Prescriptions;
